"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var async_1 = __importDefault(require("react-select/async"));
var axios_1 = __importDefault(require("axios"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var mobx_react_1 = require("mobx-react");
var input_wrapper_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/input_wrapper"));
var input_store_factory_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory"));
// Constants
var MAX_DISPLAY_OPTIONS = 9;
var MAX_SEARCH_RESULTS = 50; // Allow more results when searching
var SEARCH_DEBOUNCE_MS = 300;
var OTHER_OPTION_VALUE = '0';
var OTHER_OPTION_LABEL = 'その他';
var OTHER_OPTION_IMPORT_CATEGORY_ID = 0;
var trackWatchBrandSelected = function (productName) {
    var _a;
    if (!productName || typeof window === 'undefined') {
        return;
    }
    var w = window;
    (_a = w.dataLayer) !== null && _a !== void 0 ? _a : (w.dataLayer = []);
    w.dataLayer.push({ event: 'select_watch_product', product_name: productName });
};
var BrandBlock = (0, mobx_react_1.observer)(function (_a) {
    var isVisible = _a.isVisible, categoryId = _a.categoryId, categoryName = _a.categoryName, cardNumber = _a.cardNumber, onValueChange = _a.onValueChange, onBrandBlockClick = _a.onBrandBlockClick, onBrandBlockClear = _a.onBrandBlockClear;
    var _b = (0, react_1.useState)(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = (0, react_1.useState)([]), defaultOptions = _c[0], setDefaultOptions = _c[1];
    var _d = (0, react_1.useState)([]), allBrands = _d[0], setAllBrands = _d[1]; // Store all brands for search
    var _e = (0, react_1.useState)(null), selectedBrandOption = _e[0], setSelectedBrandOption = _e[1];
    var _f = (0, react_1.useState)(true), hasBrands = _f[0], setHasBrands = _f[1];
    var hasAutoSelected = (0, react_1.useRef)(false);
    var defaultModelCategoryId = (0, react_1.useMemo)(function () {
        if (typeof window === 'undefined') {
            return undefined;
        }
        return new URLSearchParams(window.location.search).get('model_category_id') || undefined;
    }, []);
    // Create proper MobX store using InputStoreFactory
    var store = (0, react_1.useMemo)(function () {
        return input_store_factory_1.default.createInputStore({
            type: input_store_factory_1.InputType.BRAND_BLOCK,
            name: 'brand_block',
            rawName: 'brand_block',
            label: 'モデル名',
            description: 'モデル名を選択してください',
            necessary: true
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (store.value) {
            var isOther = store.value === OTHER_OPTION_VALUE;
            var modelNameLabel = isOther ? undefined : selectedBrandOption === null || selectedBrandOption === void 0 ? void 0 : selectedBrandOption.label;
            onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(store.value, categoryId, modelNameLabel);
        }
    }, [store.value, categoryId, selectedBrandOption, onValueChange]);
    (0, react_1.useEffect)(function () {
        store.value = '';
        setInputValue('');
        setSelectedBrandOption(null);
        setHasBrands(true);
    }, [categoryId, store]);
    var buildFallbackOption = function (label) {
        var _a, _b;
        return {
            label: label,
            value: categoryId || OTHER_OPTION_VALUE,
            import_category_id: (_b = (_a = allBrands[0]) === null || _a === void 0 ? void 0 : _a.import_category_id) !== null && _b !== void 0 ? _b : OTHER_OPTION_IMPORT_CATEGORY_ID
        };
    };
    (0, react_1.useEffect)(function () {
        var loadDefaultOptions = function () { return __awaiter(void 0, void 0, Promise, function () {
            var response, brands, limitedBrands, optionsWithOther, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!categoryId) {
                            setDefaultOptions([]);
                            setHasBrands(false);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get("/api/brands/products/search?category_id=".concat(categoryId))];
                    case 2:
                        response = _a.sent();
                        brands = response.data.brands || [];
                        setAllBrands(brands);
                        if (brands.length === 0) {
                            setDefaultOptions([]);
                            setHasBrands(false);
                            onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(categoryId);
                            return [2 /*return*/];
                        }
                        setHasBrands(true);
                        limitedBrands = brands.slice(0, MAX_DISPLAY_OPTIONS);
                        optionsWithOther = __spreadArray(__spreadArray([], limitedBrands, true), [
                            {
                                label: OTHER_OPTION_LABEL,
                                value: OTHER_OPTION_VALUE,
                                import_category_id: OTHER_OPTION_IMPORT_CATEGORY_ID
                            }
                        ], false);
                        setDefaultOptions(optionsWithOther);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setDefaultOptions([]);
                        setAllBrands([]);
                        setHasBrands(false);
                        onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(categoryId);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadDefaultOptions();
    }, [categoryId, categoryName]);
    (0, react_1.useEffect)(function () {
        if (!defaultModelCategoryId || allBrands.length === 0 || hasAutoSelected.current)
            return;
        var defaultModel = allBrands.find(function (brand) { return String(brand.value) === String(defaultModelCategoryId); }) ||
            defaultOptions.find(function (opt) { return String(opt.value) === String(defaultModelCategoryId); });
        if (!defaultModel)
            return;
        hasAutoSelected.current = true;
        setSelectedBrandOption(defaultModel);
        var syntheticEvent = { target: { value: String(defaultModel.value) } };
        store.handleChange(syntheticEvent);
        onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(String(defaultModel.value));
    }, [defaultModelCategoryId, allBrands, defaultOptions, store, onBrandBlockClick]);
    var debouncedLoadOptions = (0, react_1.useCallback)((0, debounce_1.default)(function (inputValue, callback) { return __awaiter(void 0, void 0, Promise, function () {
        var isSelectedLabelInDefault, inputQuery, inputLower, filteredBrands;
        return __generator(this, function (_a) {
            if (!inputValue) {
                isSelectedLabelInDefault = selectedBrandOption
                    ? defaultOptions.some(function (opt) { return opt.label === selectedBrandOption.label; })
                    : true;
                callback(isSelectedLabelInDefault ? defaultOptions : []);
                return [2 /*return*/];
            }
            inputQuery = inputValue.trim();
            inputLower = inputQuery.toLowerCase();
            filteredBrands = allBrands
                .filter(function (opt) { return opt.label.toLowerCase().includes(inputLower); })
                .slice(0, MAX_SEARCH_RESULTS);
            if (filteredBrands.length === 0) {
                if (!inputQuery) {
                    callback(defaultOptions);
                    return [2 /*return*/];
                }
                callback([buildFallbackOption(inputQuery)]);
                return [2 /*return*/];
            }
            callback(filteredBrands);
            return [2 /*return*/];
        });
    }); }, SEARCH_DEBOUNCE_MS), [defaultOptions, categoryId, allBrands, selectedBrandOption]);
    // Cleanup debounced function on unmount to prevent memory leaks
    (0, react_1.useEffect)(function () {
        return function () {
            debouncedLoadOptions.cancel();
        };
    }, [debouncedLoadOptions]);
    var loadOptions = function (inputValue, callback) {
        debouncedLoadOptions(inputValue, callback);
    };
    var handleBlur = (0, react_1.useCallback)(function () {
        var inputLabel = inputValue.trim();
        if (!inputLabel) {
            trackWatchBrandSelected(selectedBrandOption === null || selectedBrandOption === void 0 ? void 0 : selectedBrandOption.label);
            return;
        }
        var needCreateFallback = !selectedBrandOption || selectedBrandOption.label !== inputLabel;
        if (needCreateFallback) {
            var fallbackOption = buildFallbackOption(inputLabel);
            setSelectedBrandOption(fallbackOption);
            var syntheticEvent = {
                target: {
                    value: fallbackOption.value
                }
            };
            store.handleChange(syntheticEvent);
            onBrandBlockClear === null || onBrandBlockClear === void 0 ? void 0 : onBrandBlockClear();
            onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(fallbackOption.value);
            trackWatchBrandSelected(fallbackOption.label);
            return;
        }
        onBrandBlockClear === null || onBrandBlockClear === void 0 ? void 0 : onBrandBlockClear();
        onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(categoryId || OTHER_OPTION_LABEL);
        trackWatchBrandSelected(selectedBrandOption === null || selectedBrandOption === void 0 ? void 0 : selectedBrandOption.label);
    }, [inputValue, selectedBrandOption, categoryId, allBrands, store, onBrandBlockClick, onBrandBlockClear]);
    var handleChange = function (selected) {
        if (selected) {
            setSelectedBrandOption(selected);
            var syntheticEvent = {
                target: {
                    value: selected.value
                }
            };
            store.handleChange(syntheticEvent);
            onBrandBlockClear === null || onBrandBlockClear === void 0 ? void 0 : onBrandBlockClear();
            onBrandBlockClick === null || onBrandBlockClick === void 0 ? void 0 : onBrandBlockClick(categoryId || OTHER_OPTION_VALUE);
        }
        else {
            setSelectedBrandOption(null);
            store.value = '';
            onBrandBlockClear === null || onBrandBlockClear === void 0 ? void 0 : onBrandBlockClear();
        }
    };
    var selectedValueForSelect = (0, react_1.useMemo)(function () {
        if (!store.value) {
            return null;
        }
        var selectedOption = defaultOptions.find(function (opt) { return String(opt.value) === String(store.value); });
        if (!selectedOption) {
            selectedOption = allBrands.find(function (opt) { return String(opt.value) === String(store.value); });
        }
        if (!selectedOption && selectedBrandOption && String(selectedBrandOption.value) === String(store.value)) {
            selectedOption = selectedBrandOption;
        }
        return selectedOption;
    }, [store.value, defaultOptions, allBrands, selectedBrandOption]);
    if (!isVisible || !hasBrands) {
        return null;
    }
    return (react_1.default.createElement(input_wrapper_1.default, { store: store },
        react_1.default.createElement(async_1.default, { value: selectedValueForSelect, loadOptions: loadOptions, onBlur: handleBlur, onChange: handleChange, inputValue: inputValue, onInputChange: setInputValue, isDisabled: false, placeholder: "\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044", isClearable: true, noOptionsMessage: function () { return "候補なし"; }, loadingMessage: function () { return "検索中です……"; }, defaultOptions: inputValue.trim() === '' && (!selectedBrandOption || defaultOptions.some(function (opt) { return opt.label === selectedBrandOption.label; })) ? defaultOptions : false, cacheOptions: true, styles: {
                menu: function (baseStyles) { return (__assign(__assign({}, baseStyles), { position: 'relative', zIndex: 2 })); },
                menuList: function (baseStyles) { return (__assign(__assign({}, baseStyles), { width: '100%', position: 'absolute', backgroundColor: '#fff' })); }
            } })));
});
exports.default = BrandBlock;
